export default "__VITE_ASSET__56c91b2f__"